import BaseComponent from '../../../general/js/base-component';
import Stickyfill from 'stickyfilljs';

export default class LotDetailsListNavigationComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.init();
    }

    init() {
        Stickyfill.add(this.element);
    }
}



// WEBPACK FOOTER //
// ./app/components/lot-details/js/lot-details-list-navigation.component.js